import React from "react";

export default function approve() {
  return (
    <React.Fragment>
      <div className="container-main">
        <div>Approve</div>
      </div>
    </React.Fragment>
  );
}
